import ChartDimensionToday from "./ChartDimension/ChartDimensionToday";
import ChartScatterToday from "./ChartDimension/ChartScatterToday";
const ChartDimensionContainer = () => {
  return (
    <div className="grid grid-flow-row w-full h-full rounded-md">
      <div className="flex-row  w-full h-full  rounded-md">
        <ChartDimensionToday />
      </div>
      {/* <div className="flex-row  w-full h-full  rounded-md">
        <ChartScatterToday />
      </div> */}
    </div>
  );
};

export default ChartDimensionContainer;
